// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3mDgk","tab":"Tabs_tab__qQJK8","tabActive":"Tabs_tabActive__3jnWK"};